/** Native exports accept explicit public web links, never script/file or private-host targets. */
export function safeReportLink(value) {
    if (typeof value !== 'string' || value.length > 2048 || !/^https?:\/\/\S+$/i.test(value))
        return undefined;
    try {
        const url = new URL(value);
        const host = url.hostname.toLowerCase().replace(/\.$/, '');
        if (!['http:', 'https:'].includes(url.protocol) ||
            url.username ||
            url.password ||
            !host.includes('.') ||
            /^[\d.]+$/.test(host) ||
            host.includes(':') ||
            host.startsWith('[') ||
            /\.(?:localhost|local|internal|test|invalid|onion)$/.test(host))
            return undefined;
        return url.href;
    }
    catch {
        return undefined;
    }
}
